'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      typography = _baseTheme$vstui.typography,
      cloud3 = color.cloud.getShade(3);
  return (0, _themes.createComponentTheme)(baseTheme, {
    List_backgroundColor: color.surface,
    ListDivider_color: cloud3,
    ListItem_paddingHorizontal: '16px',
    ListItem_backgroundColor_hover: color.primary.getShade(1),
    ListItem_color: color.onSurface,
    ListItem_fontFamily: typography.fontFamily,
    ListItem_fontSize: typography.fontSize,
    ListItem_fontWeight: typography.fontWeightRegular,
    ListItem_boxShadow_focus: 'inset 0 1px 0px 0px rgba(0,0,0,0.43), inset 0 -1px 0px 0px rgba(0,0,0,0.43)'
  });
};

exports.default = componentTheme;